<template>
  <p
    v-if="product.vendor"
    class="
      product-vendor
      text-body-xs-regular
    "
  >
    <responsive-image
      v-if="vendorLogo"
      class="product-vendor__image"
      :image="vendorLogo"
      :padding="false"
      ratio="1:1"
    />

    <span v-text="product.vendor" />
  </p>
</template>

<script>

/**
 * Vue: Product vendor (product-vendor)
 * -----------------------------------------------------------------------------
 * Renders vendor logo and name.
 *
 * @param {Boolean|Object} product - Product object.
 *
 */
import { convertToHandle } from '~/helpers/convert'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductVendor',

  components: {
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
    },
  },

  computed: {

    /**
     * Compute vendor logo.
     * @returns {Boolean|Object}
     */
    vendorLogo() {
      if (this.product.vendorImage?.url) {
        return this.product.vendorImage
      }

      const vendorHandle = convertToHandle(this.product.vendor)

      const vendorLogo = this.$variable('vendors')
        .find((vendor) => vendor.handle === vendorHandle)

      return vendorLogo ? vendorLogo.logo : false
    },
  },
}
</script>

<style lang="scss">
@import './product-vendor';
</style>
